<template>
  <div class="incode-webflow-component">
    <div class="row jutify-content-center">
      <div class="col">
        <div class="incode-div">
          <IncodeFlow
            @incode-url-loaded="handleIncodeUrlLoaded"
            @qr-code-iframe-loaded="handleIncodeQrCodeIframeLoaded"
          />
        </div>
      </div>
      <div class="col-4" v-if="showIncodeInstructions">
        <IncodeInstructions />
      </div>
    </div>
    <IncodeCopyLink :incode-url="incodeUrl" v-if="showIncodeCopyLink" />
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import IncodeFlow, {
  QrCodeIframeLoadedEventPayload,
} from "@/apps/merchant3/components/incode/IncodeFlow.vue";
import { IncodeUrlLoadedEventPayload } from "@/apps/merchant3/components/incode/IncodeFlow.vue";
import { datadogRum } from "@datadog/browser-rum";
import IncodeInstructions from "@/apps/merchant3/components/incode/IncodeInstructions.vue";
import IncodeCopyLink from "./IncodeCopyLink.vue";

const incodeUrl = ref("");
const showIncodeInstructions = ref(false);
// Enable only if selfService
const showIncodeCopyLink = computed(() => {
  return incodeUrl.value !== "";
});

const handleIncodeUrlLoaded = (event: IncodeUrlLoadedEventPayload) => {
  incodeUrl.value = event.incodeUrl;
  // Track creation of incode onboarding session and qr code url api call load time in RUM.
  datadogRum.addTiming("m3-api-incode-onboarding-session-created");
  datadogRum.addAction("m3-api-incode-onboarding-session-created", {
    loadTime: event.loadTime,
  });
};

const handleIncodeQrCodeIframeLoaded = (
  event: QrCodeIframeLoadedEventPayload
) => {
  // Track incode qr code iframe load time in RUM.
  datadogRum.addTiming("m3-incode-qr-code-iframe-loaded");
  datadogRum.addAction("m3-incode-qr-code-iframe-loaded", {
    loadTime: event.loadTime,
  });
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.incode-instructions {
  position: relative !important;
}
.launcher-container {
  justify-content: start !important;
}
.iframe-incode {
  flex-grow: 1;
}
.incode-ifram-div {
  width: 100%;
  height: 100vh;
}
.close-iframe-link {
  padding-top: 10px;
  padding-left: 16px;
  color: $pj-color-green;
  font-weight: bold;
  a {
    text-decoration: none;
    color: $pj-color-green;
  }
}
.incode-div {
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 700px;
}
.incode-div-ss {
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 700px;
}
</style>
